import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";

const ChartContent = ({ data }) => {
    const line = data?.chartData ?? [];

    useEffect(() => {
        const labels = [];
        const values = [];

        line.forEach(element => {
            labels.push(element.label)
            values.push(element.value)
        })

        GraphicUtils.barChart('vehicleStaying', values, labels);
    }, [line]);

    return (
        <>
            <div className="chart-report bg-[#FAFAFA] print:bg-white! pt-2 border border-[#E5E7EB] border-r-0 border-l-0 border-t-0">
                <span className="chart-title pl-4">Permanência do veículo na área monitorada</span>
                <div id="vehicleStaying"></div>
            </div>
        </>
    );
};

export default ChartContent;